import type { Locale } from '@/i18n/types'
import { del, get, patch, post } from '../client'

export type RecommendationQuote = {
  id: string
  text: string
  hidden: boolean
}

export type RecommendationRequestStatus =
  | 'pending'
  | 'opened'
  | 'in_progress'
  | 'submitted'
  | 'declined'
  | 'expired'

export type RecommendationRequestSummary = {
  id: number
  referee_name: string
  relationship: string
  company?: string
  company_experience_id?: number
  referee_verified_at?: string
  language: Locale
  status: RecommendationRequestStatus
  mode?: 'voice' | 'text'
  created_at: string
  expires_at: string
  submitted_at?: string
}

export type ReceivedRecommendation = {
  id: number
  referee_name: string
  relationship: string
  quotes: RecommendationQuote[]
  created_at: string
  company?: string
  company_experience_id?: number
  referee_linkedin_picture_url?: string
  verified_at?: string
}

export type CreateRecommendationRequestInput = {
  referee_email: string
  referee_name: string
  relationship: string
  personal_note: string
  language: Locale
  company: string
  company_experience_id?: number
}

export function createRecommendationRequest(input: CreateRecommendationRequestInput) {
  return post<{ request: RecommendationRequestSummary; link: string }>(
    'api/candidate/recommendations/requests',
    input
  )
}

export function listRecommendations() {
  return get<{
    requests: RecommendationRequestSummary[]
    recommendations: ReceivedRecommendation[]
  }>('api/candidate/recommendations')
}

export function cancelRecommendationRequest(id: number) {
  return del<{ status: string }>(`api/candidate/recommendations/requests/${id}`)
}

export function setRecommendationQuoteHidden(id: number, quoteId: string, hidden: boolean) {
  return patch<{ status: string }>(`api/candidate/recommendations/${id}/quotes/${quoteId}`, {
    hidden,
  })
}

export function deleteRecommendation(id: number) {
  return del<{ status: string }>(`api/candidate/recommendations/${id}`)
}
